import swiper from 'swiper'


function enableDisableButton(questionContaineur, quizz){
    questionContaineur.querySelectorAll('.ia-block-quizz__inner-container__field__items__item input').forEach((item,i,a) => {
        item.addEventListener('change', function(e){
            const checkIfSomeInputIsChecked = Array.from(a).filter(e => e.checked)
            console.log(checkIfSomeInputIsChecked)
            if(checkIfSomeInputIsChecked.length > 0) {
                questionContaineur.querySelector('.next-step-btn.next-question').disabled = false
            } else {
                questionContaineur.querySelector('.next-step-btn.next-question').disabled = true
            }
        })
    })
}

function quizJobjs(quizz) {
    quizz.querySelectorAll('.next-step-btn').forEach((btn) => {
        btn.addEventListener('click', function(e){
            e.preventDefault()
            hideShowStep(quizz, btn.dataset.goto)
            changeStepNumber(quizz, btn.dataset.goto)
        })
        
    })
    quizz.querySelectorAll('.ia-block-quizz__inner-container__field').forEach(e => enableDisableButton(e, quizz))
    
    quizz.querySelector('.quiz-form').addEventListener('submit', function(e){
        e.preventDefault()
        const formData = new FormData(quizz.querySelector('.quiz-form'))
        formData.append('action', 'quizzSubmissionForm')
        const xhr = new XMLHttpRequest()
        xhr.open("POST", ajaxurl, true)
        xhr.send(formData)
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4 && xhr.status == 200) {
                if(isJsonValidResponse(xhr.response)) {
                    let response = JSON.parse(xhr.response)
                    appendJobs(quizz, response)
                    quizz.classList.add('hide')
                    quizz.parentElement.querySelector('.results-content').classList.remove('hide')

                    quizz.parentElement.querySelector('.quizz-reload').addEventListener('click', function(e){
                        quizz.parentElement.querySelector('.results-content').classList.add('hide')
                        quizz.classList.remove('hide')
                        hideShowStep(quizz, '1')
                        changeStepNumber(quizz, '1')
                    })

                    const slider = new swiper(quizz.parentElement.querySelector('.swiper-container'), {
                        slidesPerView: 2.2,
                        spaceBetween: 20,
        
                        breakpoints: {
                            320: {
                                slidesPerView: 1.1,
                                spaceBetween: 20,
                            },
        
                            1024: {
                                slidesPerView: 2.2,
                                spaceBetween: 20,
                            }
                        }
                    })
                }
            }
        }
    })
}

function hideShowStep(quizz, stepToShow) {
    Array.from(quizz.querySelectorAll('.ia-block-quizz__inner-container__field')).map(quizStep => {
        if (quizStep.dataset.step === stepToShow) {
            quizStep.classList.remove('hide')
        } else {
            quizStep.classList.add('hide')
        }
        return quizStep
    })
}


function isJsonValidResponse(response) {
    try {
        JSON.parse(response)
        return true
    } catch(err) {
        console.log(err)
    }
}



function changeStepNumber(quizz, stepToShow) {
    quizz.querySelector('.current-step').innerText = stepToShow
}

function appendJobs(quizz, response) {
    const stringsNoResult = {
        fr : 'Nous n’avons pas trouvé le poste idéal pour vous, mais voici les offres qui peuvent vous concerner :',
        de : 'Wir haben nicht die ideale Stelle für Sie gefunden, aber hier sind die Angebote, die für Sie relevant sein könnten :'
    }
    if(response.res.toLowerCase() === 'empty') {
        quizz.parentElement.querySelector('#content-response-jobs').innerHTML = stringsNoResult[document.querySelector('html').lang] + '<br><br>' + response.html        
        return
    }
    quizz.parentElement.querySelector('#content-response-jobs').innerHTML = response.html
}

export { quizJobjs }